<template>
  <div data-component-group="label-dialog" data-component="add-new">
    <dialog-add
      :title="$t('create_label')"
      icon="label"
      is-fullscreen
      :is-on="true"
      :on-close="onCancel"
    >
      <template v-slot:content>
        <forms-label-add-new
          :label="{}"
          class="elevation-1"
          :is-loading="isAddingLabel"
          :on-cancel="onCancel"
          :on-submit="createLabel"
        />
      </template>
    </dialog-add>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import type { LabelPayload } from '@/api/merchy/labels';

  export default defineComponent({
    data() {
      return {
        isAddingLabel: false,
      };
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'labels' });
      },
      createLabel(label: LabelPayload) {
        this.isAddingLabel = true;

        return this.$store
          .dispatch('labels/create', label)
          .then((res) => {
            this.$router.push({ name: 'labels', query: { status: 'success' } });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isAddingLabel = false;
          });
      },
    },
  });
</script>
